import { flow, set } from 'lodash/fp';

import { ArkDocument, DocumentType } from '../../components/documents/store/types';
import { convertLocalToUTCDate } from '../../components/shared/datepicker/DatePicker';
import { MLData, MLDataValue } from '../../components/datasets/store/mlTypes';

const getDocumentType = (mlData: MLData) => {
    if (mlData.isAmendment.value) {
        return DocumentType.AMENDMENT;
    }
    if (mlData.isRestatement.value) {
        return DocumentType.RESTATEMENT;
    }
    if (mlData.isReplicatedAmendment.value) {
        return DocumentType.REPLICATION_AND_AMENDMENT;
    }
    return DocumentType.ORIGINAL;
};

const calculateDatedAsOf = (rawDatedAsOf: MLDataValue) => {
    if (typeof rawDatedAsOf !== 'string') {
        return null;
    }
    const dateString = rawDatedAsOf.replace(/(\d+)(st|nd|rd|th)/g, '$1');
    const datedAsOfLocal = new Date(dateString);
    if (isNaN(datedAsOfLocal.getTime())) {
        return null;
    }
    return convertLocalToUTCDate(datedAsOfLocal);
};

export const updateIncompleteDocumentWithMLData = (document: ArkDocument, mlData: MLData) => {
    const documentType = getDocumentType(mlData);
    const entityA = mlData.entityA.value || null;
    const entityB = mlData.entityB.value || null;
    const documentNameId = mlData.documentNameId.value || null;
    const datedAsOf = calculateDatedAsOf(mlData.datedAsOf.value);

    return flow(
        set('documentType', documentType),
        set('entityA', entityA),
        set('entityB', entityB),
        set('documentNameId', documentNameId),
        set('datedAsOf', datedAsOf),
        set('executedDate', datedAsOf),
        set('originalDocumentId', mlData.originalDocumentId.value)
    )(document);
};
